app.controller('MessageReportsMap', function($scope, _$privileges, _$breadcrumbs, _$report, _$user, _$toast, _$editmode, $rootScope, $mdDialog,uiGmapIsReady) {

	  $scope.markers = [];
	  $scope.reports;  
	  $scope.settings;

      $scope.options = {
          scrollwheel: false
      };

      $scope.show = false;
      $scope.showLoader = true;

	  $scope.windowCoords = {};

	  $scope.map = {
		visible: 0,
		zoom: 14,
		bounds: {},
		center: {
		  latitude: 0,
		  longitude: 0
		},
		options: {
		  fullscreenControl: false,
		  mapTypeControl: false,
		  streetViewControl: false
		}
	  };  

	  $scope.getMarkers = function(){				
		var promise = _$report.getMap();
		promise.then(
			function(payload) {
			  $scope.showLoader = false;
			  $scope.reports = payload.points;                    
			  $scope.map.center.latitude = payload.settings.report_map_lat;
			  $scope.map.center.longitude = payload.settings.report_map_lng;
			  $scope.map.visible = 1;
			  $scope.assignMarkersToMap();
			},
			function(errorPayload) {
				$rootScope.notification.show('error', 'Wystąpił błąd podczas próby pobierania punktów do mapy');
			}
		  );
	  };
	  
	  $scope.assignMarkersToMap = function() {      
			var markers = [];
			for (var i=0; i < $scope.reports.length; i++) {			
				markers.push({
					latitude: $scope.reports[i].lat,
					longitude: $scope.reports[i].lng,
					title: $scope.reports[i],
					id: $scope.reports[i].id,
				});
			 };
			 $scope.markers = markers;
	  };
	

      uiGmapIsReady.promise().then(function(instances) {			
			$scope.getMarkers();
      });      

      $scope.onClick = function(marker, eventName, model) {
            $scope.windowCoords.latitude = model.latitude;
            $scope.windowCoords.longitude = model.longitude;
            $scope.name = model.title;
            $scope.show = true;
      };

      $scope.closeClick = function() {
            $scope.show = false;
      };

});

